import Vue from 'vue'
import Vuex from 'vuex'
import {
  getUserInfo,
  getTaskList,
  getAchievement,
  getCardUserInfo,
  postReward,
  getMallList,
  postBuy,
  getHistoryList,
  getLiveList,
  translate,
  translate_all,
  uploadFile,
  getClubDetail,
  getFeedDetail,
  getComment,
  getRaceDetail,
  getCertificationUserInfo,
  getCertificationClubInfo,
  takeCertificationClubRequest,
  takeCertificationUserRequest,
  getUploadConfig,
  getEncryptinfo,
  bindCode,
  verifyCode,
  getReviewTask,
  getUserReviewDaySummary,
  submitReviewTask,
  saveFeedback,
  getClubRanking,
  getClubPref,
  setClubPref,
  getClubAchievement,
  getClubAchievementPref,
  setClubAchievementPref,
  getZone,
  setZone,
  disbandtZone,
  invitations,
  onInvitation,
  invite,
  candidates,
  feedList,
  feedDelete,
  getMediaAuthInfo,
  saveMediaAuth,
  saveEditorAuth,
  getClubFeedList,
  getTopicFeedList,
} from '@/api'
import getEnv from '@/utils/env'
import {
  UserInfo,
  SignInfo,
  InitData,
  ParamObject,
  LiveInfoParam,
  LiveMessage,
  LiveData,
  ImageInfo,
  TranslateReq,
  TranslateAllLangReq
} from '@/model'
import { formatDateTime, formatRaceDateTime } from '@/utils/date'

Vue.use(Vuex)

const cardUserInfo: UserInfo = {
  name: '',
  headPic: '',
  mCoin: 0
}

const signInfo: SignInfo = {
  progress: 0,
  today: 0,
  tomorrow: 0,
  stages: {}
}

const initData: InitData = {
  loading: true,
  rewardRs: -1,
  totalCoins: 0,
  remainCoins: 0,
  isNew: false,
  buyRs: -1,
  authSubmitRes: -1,
  verifyCodeRes: -1,
  bindCodeRes: -1,
  submitReviewTaskRes: -1, // 提交审核任务的返回状态
  setClubPrefRes: -1,
  setClubAchievementPrefRes: -1,
  setZoneRes: -1,
  disbandtZoneRes: -1,
  onInvitationRes: -1,
  inviteRes: -1,
  feedDeleteRes: -1,
}

export default new Vuex.Store({
  state: {
    initData,
    taskList: [],
    achievements: [],
    cardUserInfo,
    signInfo,
    mallInfo: {},
    historyInfo: {} as any,
    liveList: {} as LiveData,
    historyLiveList: {} as LiveData,
    translateData: [],
    translateAllData: [],
    clubDetail: {},
    feedDetail: {},
    comment: {},
    raceDetail: {},
    underReviewStatus: -1,
    underReviewTime: '',
    uploadConfig: {},
    userInfo: {},
    reviewTask: {}, // 审核任务
    userReviewDaySummary: {}, // 用户的审核概述
    clubRanking: {},
    clubPref: {},
    clubAchievement: {},
    clubAchievementPref: {},
    zoneInfo: {},
    candidates: {}, // 空间邀请列表
    invitations: {}, // 空间被邀请列表
    feedList: {}, // 空间feeds
    clubFeedList: [], // 俱乐部帖子列表
    topicFeedList: [], // 话题帖子列表
  },
  getters: {
    taskList (state, getters) {
      return state.taskList
    },
    achievements (state) {
      return state.achievements
    },
    cardUserInfo (state) {
      return state.cardUserInfo
    },
    signInfo (state) {
      return state.signInfo
    },
    initData (state) {
      return state.initData
    },
    mallInfo (state) {
      return state.mallInfo
    },
    historyInfo (state) {
      return state.historyInfo
    },
    liveList (state) {
      return state.liveList
    },
    historyLiveList (state) {
      return state.historyLiveList
    },
    translateData (state) {
      return state.translateData
    },
    translateAllData (state) {
      return state.translateAllData
    },
    clubDetail (state) {
      return state.clubDetail;
    },
    feedDetail (state) {
      return state.feedDetail;
    },
    comment (state) {
      return state.comment;
    },
    raceDetail (state) {
      return state.raceDetail;
    },
    underReviewStatus (state) {
      return state.underReviewStatus;
    },
    underReviewTime (state) {
      return state.underReviewTime;
    },
    uploadConfig (state) {
      return state.uploadConfig;
    },
    userInfo (state) {
      return state.userInfo;
    },
    reviewTask (state) {
      return state.reviewTask;
    },
    userReviewDaySummary (state) {
      return state.userReviewDaySummary;
    },
    clubRanking (state) {
      return state.clubRanking;
    },
    clubPref (state) {
      return state.clubPref;
    },
    clubAchievement (state) {
      return state.clubAchievement;
    },
    clubAchievementPref (state) {
      return state.clubAchievementPref;
    },
    zoneInfo (state) {
      return state.zoneInfo;
    },
    candidates (state) {
      return state.candidates;
    },
    invitations (state) {
      return state.invitations;
    },
    feedList (state) {
      return state.feedList;
    },
    clubFeedList (state) {
      return state.clubFeedList;
    },
    topicFeedList (state) {
      return state.topicFeedList;
    },
  },
  mutations: {
    updateTaskList (state, data) {
      state.taskList = data
    },
    updateAchievements (state, data) {
      state.achievements = data
    },
    updateCardUserInfo (state, data) {
      state.cardUserInfo = data
    },
    updateSignInfo (state, data) {
      state.signInfo = data
    },
    updateInitData (state, data: {key: string, value: any}) {
      state.initData[data.key] = data.value
    },
    updateMallInfo (state, data) {
      state.mallInfo = data
    },
    updateHistoryInfo (state, data) {
      if (data && data.data && data.data.length && state.historyInfo.data) {
        state.historyInfo.data = state.historyInfo.data.concat(data.data)
        state.historyInfo.hasMore = data.hasMore
      } else {
        state.historyInfo = data
      }
    },
    updateLiveList (state, data: LiveData) {
      if (data && data.msg && Array.isArray(data.msg)) {
        state.liveList.msg = state.liveList.msg.concat(data.msg)
        state.liveList.hasMore = data.hasMore
      }
    },
    updateHistoryLiveList (state, data: LiveData) {
      if (data && data.msg && Array.isArray(data.msg)) {
        state.historyLiveList.msg = data.msg.concat(state.historyLiveList.msg)
        state.historyLiveList.hasMore = data.hasMore
        state.liveList.msg = data.msg.concat(state.liveList.msg) //追加到页面数据前面
      }
    },
    updateTranslate (state, data) {
      state.translateData = data
    },
    updateTranslateAll (state, data) {
      state.translateAllData = data
    },
    resetLiveList (state) {
      state.liveList = {msg: [], hasMore: false}
      state.historyLiveList = {msg: [], hasMore: false}
    },
    updateClubDetail (state, data) {
      state.clubDetail = data;
    },
    updateFeedDetail (state, data) {
      state.feedDetail = data;
    },
    updateComment (state, data) {
      state.comment = data;
    },
    updateRaceDetail (state, data) {
      state.raceDetail = data;
    },
    updateUnderReviewStatus (state, data) {
      if (typeof data == 'object') {
        state.underReviewTime = data.verifyTime;
        state.underReviewStatus = data.statusCode;
      } else {
        state.underReviewStatus = data;
      }
    },
    updateUploadConfig (state, data) {
      state.uploadConfig = data;
    },
    updateUserInfo (state, data) {
      state.userInfo = data;
    },
    updateReviewTask (state, data) {
      state.reviewTask = data;
    },
    updateUserReviewDaySummary (state, data) {
      state.userReviewDaySummary = data;
    },
    updateClubRanking (state, data) {
      state.clubRanking = data;
    },
    updateClubPref (state, data) {
      state.clubPref = data;
    },
    updateClubAchievement (state, data) {
      state.clubAchievement = data;
    },
    updateClubAchievementPref (state, data) {
      state.clubAchievementPref = data;
    },
    updateZoneInfo (state, data) {
      state.zoneInfo = data;
    },
    updateCandidates (state, data) {
      state.candidates = data;
    },
    updateInvitations (state, data) {
      state.invitations = data;
    },
    updateFeedList (state, data) {
      state.feedList = data;
    },
    updateClubFeedList (state, data) {
      state.clubFeedList = data;
    },
    updateTopicFeedList (state, data) {
      state.topicFeedList = data;
    },
  },
  actions: {
    async getTaskList ({ commit }, openId: string) {
      const res = await getTaskList({openId})
      if (res.code && res.code !== 0) {
        throw res
      }
      commit('updateTaskList', res.data.tasks)
      commit('updateSignInfo', res.data.sign)
      commit('updateInitData', {key: 'remainCoins', value: res.data.remainCoins})
      commit('updateInitData', {key: 'totalCoins', value: res.data.totalCoins})
      commit('updateInitData', {key: 'isNew', value: res.data.isNew})
    },
    async getAchievements ({commit}, openId: string) {
      const res = await getAchievement({openId})
      if (res.code && res.code !== 0) {
        throw res
      }
      commit('updateAchievements', res.data)
    },
    async getCardUserInfo ({commit}, openId: string) {
      const res = await getCardUserInfo({openId})
      if (res.code && res.code !== 0) {
        throw res
      }
      commit('updateInitData', {key: 'loading', value: false})
      commit('updateCardUserInfo', res.data)
    },
    async postReward ({commit}, params: ParamObject) {
      const res = await postReward(params)
      if (res.code && res.code !== 0) {
        throw res
      }
      commit('updateInitData', {key: 'rewardRs', value: 0})
    },
    resetInitData ({commit}, initData: InitData) {
      commit('updateInitData', {key: initData.key, value: initData.value})
    },
    async getMallList ({commit}, params: ParamObject) {
      const res = await getMallList(params)
      if (res.code && res.code !== 0) {
        throw res
      }
      commit('updateMallInfo', res.data)
    },
    async postBuy ({commit}, params: ParamObject) {
      const res = await postBuy(params)
      if (res.code && res.code !== 0) {
        throw res
      }
      commit('updateInitData', {key: 'buyRs', value: 0})
    },
    async getHistoryList ({commit}, params: ParamObject) {
      if (params.pageNo === 1) {
        //reset
        commit('updateHistoryInfo', {data: [], hasMore: false})
      }
      const res = await getHistoryList(params)
      if (res.code && res.code !== 0) {
        throw res
      }
      commit('updateHistoryInfo', res.data)
    },
    async getLiveList ({commit}, params: LiveInfoParam) {
      if (!params.lastMsgId) {
        //reset
        commit('resetLiveList')
      }
      const res = await getLiveList(params)
      if (res.data.code && res.data.code !== 0) {
        throw res
      }
      if (params.isHistory) {
        //下拉获取历史数据
        commit('updateHistoryLiveList', res.data.data)
      } else {
        //更新最新数据
        commit('updateLiveList', res.data.data)
      }
    },
    async translate ({commit}, params: TranslateReq) {
      const res = await translate(params)
      if (res.data.code && res.data.code !== 0) {
        throw res
      }
      commit('updateTranslate', res.data.data)
    },
    async translateAll ({commit}, params: TranslateAllLangReq) {
      const res = await translate_all(params)
      if (res.data.code && res.data.code !== 0) {
        throw res
      }
      commit('updateTranslateAll', res.data.data)
    },
    async uploadFile ({commit}, params: object) {
      console.log('params:', params);
      const res = await uploadFile(params);
      console.log('res:', res);
    },
    async getClubDetail ({commit}, params: object) {
      const res = await getClubDetail(params);
      // {"error":{"errmsg":"invalid field OpenId: value '' must not be an emptystring","result":3}}

      if (res.error) {
        throw res
      }
      commit('updateClubDetail', res);
    },
    async getFeedDetail ({commit}, params: object) {
      let res = await getFeedDetail(params);
      // for test
      // res = {"error":{"errmsg":"invalid field OpenId: value '' must not be an empty string","result":3}};
      // if (res.error) {
      //   throw res
      // }
      commit('updateFeedDetail', res);
    },
    async getComment ({commit}, params: object) {
      const res = await getComment(params);
      if (res.error) {
        throw res
      }
      const newData: any = [];
      res.data.forEach((item: any, index: number) => {
        if (item.replyData) {
          const newReply: any = [];
          item.replyData.replies.forEach((sitem: any, sindex: number) => {
            if (sindex < 3) {
              sitem.replyDate = formatDateTime(new Date(sitem.lastTime*1000));
              newReply.push(sitem);
            }
          });
          item.replyData.replies = newReply;
        }
        if (index < 3) {
          newData.push(item);
        }

      });
      res.data = newData;
      console.log(res)
      commit('updateComment', res);
    },
    async getRaceDetail ({commit}, params: object) {
      const res = await getRaceDetail(params);
      if (res.error) {
        throw res
      }
      res.tournament.base.detail = res.tournament.base.detail.split('\n');
      res.tournament.base.stime = formatRaceDateTime(new Date(res.tournament.base.stime*1000));
      const statusMap = {
        1: 'Registering',
        2: 'Registration has ended',
        3: 'In progress',
        4: 'Completed',
      } as any;
      res.tournament.base.status = statusMap[res.tournament.base.status];
      commit('updateRaceDetail', res);
    },
    async getUploadConfig ({commit}, params: object) {
      const res = await getUploadConfig(params);
      if (res.error) {
        throw res
      }
      commit('updateUploadConfig', res);
      return res;
    },
    async getCertificationUserInfo({commit}, params: any) {
      let res = null;
      if (params.type == 'auth') {
        res = await getCertificationUserInfo(params);
      } else {
        res = await getCertificationClubInfo(params);
      }
      // if (res.code) {
      //   throw res
      // }
      // 这个0是未提交申请，1是审核中，2是审核不通过，3是审核通过
      // res = {status: 0}; // for test
      commit('updateUnderReviewStatus', res.status);
    },
    async takeCertificationClubRequest ({commit}, params: ParamObject) {
      const res = await takeCertificationClubRequest(params)
      if (res.code && res.code !== 0) {
        commit('updateInitData', {key: 'authSubmitRes', value: -1})
        return;
      }
      commit('updateInitData', {key: 'authSubmitRes', value: 0})
    },
    async takeCertificationUserRequest ({commit}, params: ParamObject) {
      const res = await takeCertificationUserRequest(params)
      if (res.code && res.code !== 0) {
        commit('updateInitData', {key: 'authSubmitRes', value: -1})
        return;
      }
      commit('updateInitData', {key: 'authSubmitRes', value: 0})
    },
    async getEncryptinfo ({commit}, params: object) {
      const res = await getEncryptinfo(params);
      // if (res.error) {
      //   throw res
      // }
      commit('updateUserInfo', res);
    },
    async verifyCode ({commit}, params: ParamObject) {
      const res = await verifyCode(params)
      if (res.error) {
        commit('updateInitData', {key: 'verifyCodeRes', value: -1})
        return;
      }
      if (res.pass) {
        commit('updateInitData', {key: 'verifyCodeRes', value: 0})
      } else {
        commit('updateInitData', {key: 'verifyCodeRes', value: -1})
      }
    },
    async bindCode ({commit}, params: ParamObject) {
      const res = await bindCode(params)
      if (res.error) {
        commit('updateInitData', {key: 'bindCodeRes', value: -1})
        return;
      }
      commit('updateInitData', {key: 'bindCodeRes', value: 0})
    },
    async getReviewTask ({commit}, params: object) {
      let res = await getReviewTask(params);
      commit('updateReviewTask', res);
    },
    async getUserReviewDaySummary ({commit}, params: object) {
      let res = await getUserReviewDaySummary(params);
      commit('updateUserReviewDaySummary', res);
    },
    async submitReviewTask ({commit}, params: ParamObject) {
      const res = await submitReviewTask(params)
      if (res.error) {
        commit('updateInitData', {key: 'submitReviewTaskRes', value: -1})
        return;
      }
      commit('updateInitData', {key: 'submitReviewTaskRes', value: 0})
    },
    async saveFeedback ({commit}, params: ParamObject) {
      const res = await saveFeedback(params)
      if (res.code && res.code !== 0) {
        commit('updateInitData', {key: 'submitFeedbackRes', value: -1})
        return;
      }
      commit('updateInitData', {key: 'submitFeedbackRes', value: 0})
    },
    async getClubRanking ({commit}, params: object) {
      let res = await getClubRanking(params);
      commit('updateClubRanking', res);
    },
    async getClubPref ({commit}, params: object) {
      let res = await getClubPref(params);
      commit('updateClubPref', res);
    },
    async setClubPref ({commit}, params: object) {
      let res = await setClubPref(params);
      if (res.error) {
        commit('updateInitData', {key: 'setClubPrefRes', value: -1})
        return;
      }
      commit('updateInitData', {key: 'setClubPrefRes', value: 0})
    },
    async getClubAchievement ({commit}, params: object) {
      let res = await getClubAchievement(params);
      // for test
      // if(params.begin == 0) {
      //   res = {"list":[{"time":"20230703","infos":[]},{"time":"20230526","infos":[{"type":"ACHIEVEMENT_TYPE_SELF","subItem":[{"subType":"ACHI_SUB_SINGLE_FEED_LIKED","contentData":[" ​#pubgmobile​ ​#pubgm​ ​#gameplay​ ​#handcam​ ​#fyp​ ​#bgmi​ ​#livik​ ​#erangel​ ​#ipad​ ​#new​","5"],"nextLevel":"0","time":"1685103200"},{"subType":"ACHI_SUB_SINGLE_FEED_LIKED","contentData":[" ​#pubgmobile​ ​#pubgm​ ​#gameplay​ ​#handcam​ ​#fyp​ ​#bgmi​ ​#livik​ ​#erangel​ ​#ipad​ ​#new​","3"],"nextLevel":"5","time":"1685082927"},{"subType":"ACHI_SUB_SINGLE_FEED_LIKED","contentData":[" ​#pubgmobile​ ​#pubgm​ ​#gameplay​ ​#handcam​ ​#fyp​ ​#bgmi​ ​#livik​ ​#erangel​ ​#ipad​ ​#new​","2"],"nextLevel":"3","time":"1685070021"}],"latest":"1685103200"}]},{"time":"20230418","infos":[{"type":"ACHIEVEMENT_TYPE_SELF","subItem":[{"subType":"ACHI_SUB_SINGLE_FEED_LIKED","contentData":["深圳​#lewin2​ ","1"],"nextLevel":"2","time":"1681810927"}],"latest":"1681810927"}]},{"time":"20230316","infos":[{"type":"ACHIEVEMENT_TYPE_SELF","subItem":[{"subType":"ACHI_SUB_SINGLE_FEED_LIKED","contentData":[" ​#pubgmobile​ ​#pubgm​ ​#gameplay​ ​#handcam​ ​#fyp​ ​#bgmi​ ​#livik​ ​#erangel​ ​#ipad​ ​#new​","3"],"nextLevel":"5","time":"1678948872"}],"latest":"1678948872"}]},{"time":"20230310","infos":[{"type":"ACHIEVEMENT_TYPE_SELF","subItem":[{"subType":"ACHI_SUB_SINGLE_FEED_LIKED","contentData":[" ​#pubgmobile​ ​#pubgm​ ​#gameplay​ ​#handcam​ ​#fyp​ ​#bgmi​ ​#livik​ ​#erangel​ ​#ipad​ ​#new​","3"],"nextLevel":"5","time":"1678452432"}],"latest":"1678452432"}]},{"time":"20230301","infos":[{"type":"ACHIEVEMENT_TYPE_SELF","subItem":[{"subType":"ACHI_SUB_SINGLE_FEED_LIKED","contentData":[" ​#pubgmobile​ ​#pubgm​ ​#gameplay​ ​#handcam​ ​#fyp​ ​#bgmi​ ​#livik​ ​#erangel​ ​#ipad​ ​#new​","2"],"nextLevel":"3","time":"1677651244"},{"subType":"ACHI_SUB_SINGLE_FEED_LIKED","contentData":[" ​#pubgmobile​ ​#pubgm​ ​#gameplay​ ​#handcam​ ​#fyp​ ​#bgmi​ ​#livik​ ​#erangel​ ​#ipad​ ​#new​","2"],"nextLevel":"3","time":"1677651047"}],"latest":"1677651244"}]},{"time":"20230228","infos":[{"type":"ACHIEVEMENT_TYPE_SELF","subItem":[{"subType":"ACHI_SUB_SINGLE_FEED_LIKED","contentData":[" ​#pubgmobile​ ​#pubgm​ ​#gameplay​ ​#handcam​ ​#fyp​ ​#bgmi​ ​#livik​ ​#erangel​ ​#ipad​ ​#new​","3"],"nextLevel":"5","time":"1677552848"},{"subType":"ACHI_SUB_SINGLE_FEED_LIKED","contentData":[" ​#pubgmobile​ ​#pubgm​ ​#gameplay​ ​#handcam​ ​#fyp​ ​#bgmi​ ​#livik​ ​#erangel​ ​#ipad​ ​#new​","3"],"nextLevel":"5","time":"1677552730"},{"subType":"ACHI_SUB_SINGLE_FEED_LIKED","contentData":[" ​#pubgmobile​ ​#pubgm​ ​#gameplay​ ​#handcam​ ​#fyp​ ​#bgmi​ ​#livik​ ​#erangel​ ​#ipad​ ​#new​","1"],"nextLevel":"2","time":"1677552666"},{"subType":"ACHI_SUB_SINGLE_FEED_LIKED","contentData":[" ​#pubgmobile​ ​#pubgm​ ​#gameplay​ ​#handcam​ ​#fyp​ ​#bgmi​ ​#livik​ ​#erangel​ ​#ipad​ ​#new​","2"],"nextLevel":"3","time":"1677552666"},{"subType":"ACHI_SUB_SINGLE_FEED_LIKED","contentData":[" ​#pubgmobile​ ​#pubgm​ ​#gameplay​ ​#handcam​ ​#fyp​ ​#bgmi​ ​#livik​ ​#erangel​ ​#ipad​ ​#new​","2"],"nextLevel":"3","time":"1677552611"},{"subType":"ACHI_SUB_SINGLE_FEED_LIKED","contentData":[" ​#pubgmobile​ ​#pubgm​ ​#gameplay​ ​#handcam​ ​#fyp​ ​#bgmi​ ​#livik​ ​#erangel​ ​#ipad​ ​#new​","3"],"nextLevel":"5","time":"1677552611"},{"subType":"ACHI_SUB_SINGLE_FEED_LIKED","contentData":[" ​#pubgmobile​ ​#pubgm​ ​#gameplay​ ​#handcam​ ​#fyp​ ​#bgmi​ ​#livik​ ​#erangel​ ​#ipad​ ​#new​","1"],"nextLevel":"2","time":"1677552611"},{"subType":"ACHI_SUB_SINGLE_FEED_LIKED","contentData":[" ​#pubgmobile​ ​#pubgm​ ​#gameplay​ ​#handcam​ ​#fyp​ ​#bgmi​ ​#livik​ ​#erangel​ ​#ipad​ ​#new​","2"],"nextLevel":"3","time":"1677552547"},{"subType":"ACHI_SUB_SINGLE_FEED_LIKED","contentData":[" ​#pubgmobile​ ​#pubgm​ ​#gameplay​ ​#handcam​ ​#fyp​ ​#bgmi​ ​#livik​ ​#erangel​ ​#ipad​ ​#new​","1"],"nextLevel":"2","time":"1677552547"},{"subType":"ACHI_SUB_SINGLE_FEED_LIKED","contentData":[" ​#pubgmobile​ ​#pubgm​ ​#gameplay​ ​#handcam​ ​#fyp​ ​#bgmi​ ​#livik​ ​#erangel​ ​#ipad​ ​#new​","1"],"nextLevel":"2","time":"1677552494"},{"subType":"ACHI_SUB_SINGLE_FEED_LIKED","contentData":[" ​#pubgmobile​ ​#pubgm​ ​#gameplay​ ​#handcam​ ​#fyp​ ​#bgmi​ ​#livik​ ​#erangel​ ​#ipad​ ​#new​","2"],"nextLevel":"3","time":"1677552494"},{"subType":"ACHI_SUB_SINGLE_FEED_LIKED","contentData":[" ​#pubgmobile​ ​#pubgm​ ​#gameplay​ ​#handcam​ ​#fyp​ ​#bgmi​ ​#livik​ ​#erangel​ ​#ipad​ ​#new​","1"],"nextLevel":"2","time":"1677552429"},{"subType":"ACHI_SUB_SINGLE_FEED_LIKED","contentData":[" ​#pubgmobile​ ​#pubgm​ ​#gameplay​ ​#handcam​ ​#fyp​ ​#bgmi​ ​#livik​ ​#erangel​ ​#ipad​ ​#new​","1"],"nextLevel":"2","time":"1677552366"},{"subType":"ACHI_SUB_SINGLE_FEED_LIKED","contentData":[" ​#pubgmobile​ ​#pubgm​ ​#gameplay​ ​#handcam​ ​#fyp​ ​#bgmi​ ​#livik​ ​#erangel​ ​#ipad​ ​#new​","3"],"nextLevel":"5","time":"1677552366"},{"subType":"ACHI_SUB_SINGLE_FEED_LIKED","contentData":[" ​#pubgmobile​ ​#pubgm​ ​#gameplay​ ​#handcam​ ​#fyp​ ​#bgmi​ ​#livik​ ​#erangel​ ​#ipad​ ​#new​","1"],"nextLevel":"2","time":"1677552366"},{"subType":"ACHI_SUB_SINGLE_FEED_LIKED","contentData":[" ​#pubgmobile​ ​#pubgm​ ​#gameplay​ ​#handcam​ ​#fyp​ ​#bgmi​ ​#livik​ ​#erangel​ ​#ipad​ ​#new​","1"],"nextLevel":"2","time":"1677552366"},{"subType":"ACHI_SUB_SINGLE_FEED_LIKED","contentData":[" ​#pubgmobile​ ​#pubgm​ ​#gameplay​ ​#handcam​ ​#fyp​ ​#bgmi​ ​#livik​ ​#erangel​ ​#ipad​ ​#new​","2"],"nextLevel":"3","time":"1677552312"}],"latest":"1677552848"}]},{"time":"20230224","infos":[{"type":"ACHIEVEMENT_TYPE_SELF","subItem":[{"subType":"ACHI_SUB_SINGLE_FEED_LIKED","contentData":[" ​#pubgmobile​ ​#pubgm​ ​#gameplay​ ​#handcam​ ​#fyp​ ​#bgmi​ ​#livik​ ​#erangel​ ​#ipad​ ​#new​","2"],"nextLevel":"3","time":"1677226933"},{"subType":"ACHI_SUB_SINGLE_FEED_LIKED","contentData":[" ​#pubgmobile​ ​#pubgm​ ​#gameplay​ ​#handcam​ ​#fyp​ ​#bgmi​ ​#livik​ ​#erangel​ ​#ipad​ ​#new​","1"],"nextLevel":"2","time":"1677226567"}],"latest":"1677226933"}]},{"time":"20221116","infos":[{"type":"ACHIEVEMENT_TYPE_BADGE","subItem":[{"subType":"ACHI_SUB_BADGE_SUPERSTAR","contentData":["俱乐部万人迷"],"nextLevel":"0","time":"1668591715"}],"latest":"1668591715"}]},{"time":"20220909","infos":[{"type":"ACHIEVEMENT_TYPE_CLUB","subItem":[{"subType":"ACHI_SUB_CLUB_MEMBERS","contentData":["","5"],"nextLevel":"0","time":"1662705725"}],"latest":"1662705725"}]}],"next":"20220908","isFinish":0,"overview":[{"title":"魅力十足","icon":"http://www.qq.com","conditionNumber":"100000","finishConditionNumber":"0","isFinish":false,"sort":"9"},{"title":"CLUB达人","icon":"http://www.qq.com","conditionNumber":"1000","finishConditionNumber":"0","isFinish":false,"sort":"8"},{"title":"妙语连珠","icon":"http://www.qq.com","conditionNumber":"200","finishConditionNumber":"0","isFinish":false,"sort":"7"},{"title":"俱乐部超级巨星","icon":"http://www.qq.com","conditionNumber":"100000","finishConditionNumber":"100000","isFinish":true,"sort":"6"},{"title":"CLUB Superstar","icon":"http://www.qq.com","conditionNumber":"10000","finishConditionNumber":"10000","isFinish":true,"sort":"5"},{"title":"俱乐部名人","icon":"http://www.qq.com","conditionNumber":"1000","finishConditionNumber":"1000","isFinish":true,"sort":"4"},{"title":"CLUB Rising Star","icon":"http://www.qq.com","conditionNumber":"1000","finishConditionNumber":"1000","isFinish":true,"sort":"3"}]}
      // }
      commit('updateClubAchievement', res);
    },
    async getClubAchievementPref ({commit}, params: object) {
      let res = await getClubAchievementPref(params);
      commit('updateClubAchievementPref', res);
    },
    async setClubAchievementPref ({commit}, params: object) {
      let res = await setClubAchievementPref(params);
      if (res.error) {
        commit('updateInitData', {key: 'setClubAchievementPrefRes', value: -1})
        return;
      }
      commit('updateInitData', {key: 'setClubAchievementPrefRes', value: 0})
    },
    async getZone ({commit}, params: object) {
      let res = await getZone(params);
      commit('updateZoneInfo', res);
    },
    async getCandidates ({commit}, params: object) {
      let res = await candidates(params);
      commit('updateCandidates', res);
    },
    async getInvitations ({commit}, params: object) {
      let res = await invitations(params);
      commit('updateInvitations', res);
    },
    async setZone ({commit}, params: object) {
      let res = await setZone(params);
      if (res.error) {
        commit('updateInitData', {key: 'setZoneRes', value: -1})
        return;
      }
      commit('updateInitData', {key: 'setZoneRes', value: 0})
    },
    async invite ({commit}, params: object) {
      let res = await invite(params);
      if (res.error) {
        commit('updateInitData', {key: 'inviteRes', value: -1})
        return;
      }
      commit('updateInitData', {key: 'inviteRes', value: 0})
    },
    async disbandtZone ({commit}, params: object) {
      let res = await disbandtZone(params);
      if (res.error) {
        commit('updateInitData', {key: 'disbandtZoneRes', value: -1})
        return;
      }
      commit('updateInitData', {key: 'disbandtZoneRes', value: 0})
    },
    async onInvitation ({commit}, params: object) {
      let res = await onInvitation(params);
      if (res.error) {
        commit('updateInitData', {key: 'onInvitationRes', value: res.error.result})
        return;
      }
      commit('updateInitData', {key: 'onInvitationRes', value: 0})
    },
    async getFeedList ({commit}, params: object) {
      let res = await feedList(params);
      commit('updateFeedList', res);
    },
    async feedDelete ({commit}, params: object) {
      let res = await feedDelete(params);
      if (res.error) {
        commit('updateInitData', {key: 'feedDeleteRes', value: -1})
        return;
      }
      commit('updateInitData', {key: 'feedDeleteRes', value: 0})
    },
    async getMediaAuthInfo({commit}, params: any) {
      let res = null;
      res = await getMediaAuthInfo(params);
      commit('updateUnderReviewStatus', res);
    },
    async saveMediaAuth ({commit}, params: ParamObject) {
      const res = await saveMediaAuth(params)
      if (res.error) {
        commit('updateInitData', {key: 'authSubmitRes', value: -1})
        return;
      }
      commit('updateInitData', {key: 'authSubmitRes', value: 0})
    },
    async saveEditorAuth ({commit}, params: ParamObject) {
      const res = await saveEditorAuth(params)
      if (res.error) {
        commit('updateInitData', {key: 'authSubmitRes', value: -1})
        return;
      }
      commit('updateInitData', {key: 'authSubmitRes', value: 0})
    },
    async getClubFeedList ({commit}, params: object) {
      const res = await getClubFeedList(params);
      // {"error":{"errmsg":"invalid field OpenId: value '' must not be an emptystring","result":3}}

      if (res.error) {
        throw res
      }
      commit('updateClubFeedList', res);
    },
    async getTopicFeedList ({commit}, params: object) {
      const res = await getTopicFeedList(params);
      // {"error":{"errmsg":"invalid field OpenId: value '' must not be an emptystring","result":3}}

      if (res.error) {
        throw res
      }
      commit('updateTopicFeedList', res);
    },
  },
  modules: {},
  strict: getEnv() !== 'production'
})
